










































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { StudentFile, SearchCondition } from "../../modules/student/FileList"

export interface Data {
  condition: SearchCondition
  studentFiles: StudentFile[]
  fields: any[]
  errors: string[]
  perPage: number
  currentPage: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      studentFiles: [],
      fields: [
        {key: "updated_at", label: "配布日", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "190px"}},
        {key: "title", label: "表題", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "comment", label: "コメント", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "is_downloaded", label: "状態", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
        {key: "download", label: "参照", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
      ],
      errors: [],
      perPage: 100,
      currentPage: 1,
    });

    /******************************
     * 答案PDFダウンロード
     ******************************/

    const download = async (id: number, student_no_character: string) => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/student/file_list/download/${id}/${student_no_character}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = JSON.parse(new TextDecoder().decode(error.response.data)).errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const searchClick = async () => {
      await search();
    }

    const clearCondition = () => {
      state.condition = new SearchCondition();
    }

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/student/file_list?student_no_character=${context.root.$store.state.student_no_character}&${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.studentFiles = response.data.student_files.map((x: any) => new StudentFile(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      search();
    });

    return {
      ...toRefs(state),
      download,
      searchClick,
      clearCondition,
    }
  }
});
